import { BulkPostDelete } from 'src/pages/scheduledPost/Grid/BulkPostDelete';
import { Table, TableContainer } from '@mui/material';
import { useEffect, useState } from 'react';
import Scrollbar from 'src/components/scrollbar/Scrollbar';
import DynamicHeightComponent from 'src/utils/dynamicSize.component';
import ScheduledPostGridBody from './allPostGridBody.component';
import ScheduledPostGridHead from './allPostGridHead.component';
import ScheduledPostGridPagination from './allPostGridPagination.component';

const ScheduledPostGrid = ({ scheduledPostList, order, orderBy, isOrgEvent, handleReCallScheduledPost,isShowOfferBanner=false  }) => {
  //Table Variables
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => { setPage((current) => Math.min(current, Math.max(0, Math.ceil((scheduledPostList?.length || 0) / rowsPerPage) - 1))); }, [scheduledPostList, rowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    let orderStr = isAsc ? 'desc' : 'asc';
    handleReCallScheduledPost(property, orderStr);
  };

  const handleRecallScheduledPostWithSort = () => {
    handleReCallScheduledPost(orderBy, order);
  };

  return (
    <BulkPostDelete rows={scheduledPostList} page={page} rowsPerPage={rowsPerPage} isOrgEvent={isOrgEvent} onDeleted={() => { setPage(0); handleRecallScheduledPostWithSort(); }}>
      <DynamicHeightComponent>
        <Scrollbar>
          <TableContainer
            sx={{
               height: isShowOfferBanner ? 'calc(100vh - 418px)' : 'calc(100vh - 368px)',
            }}
          >
            <Table stickyHeader size="small">
              <ScheduledPostGridHead
                scheduledPostList={scheduledPostList}
                order={order}
                orderBy={orderBy}
                handleRequestSort={handleRequestSort}
              ></ScheduledPostGridHead>
              <ScheduledPostGridBody
                scheduledPostList={scheduledPostList}
                page={page}
                rowsPerPage={rowsPerPage}
                isOrgEvent={isOrgEvent}
                handleReCallScheduledPost={handleRecallScheduledPostWithSort}
              ></ScheduledPostGridBody>
            </Table>
          </TableContainer>
          <ScheduledPostGridPagination
            scheduledPostList={scheduledPostList}
            page={page}
            rowsPerPage={rowsPerPage}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
          ></ScheduledPostGridPagination>
        </Scrollbar>
      </DynamicHeightComponent>
    </BulkPostDelete>
  );
};
export default ScheduledPostGrid;
